module.exports = __webpack_public_path__ + "img/Group_27922.98d360b2.svg";